import { useMutation } from "@tanstack/react-query";

import { useAuthenticated } from "../auth/SessionProvider";
import { post } from "./client";
import type { Group, ScoreReport } from "./types";

/** Explicit trigger: scoring a whole group scans the answers table. */
export function useScoreReport() {
  const { token } = useAuthenticated();
  return useMutation({
    mutationFn: (input: { group: Group; regionId?: number; siteId?: number }) =>
      post<ScoreReport>("/scores/report", input, token)
  });
}

/** RFC 4180 CSV with a BOM so Excel opens it as UTF-8. */
export function toCsv(header: readonly string[], rows: ReadonlyArray<ReadonlyArray<string | number | boolean | null>>): string {
  const cell = (value: string | number | boolean | null) => {
    const text = value === null ? "" : String(value);
    return /[",\r\n]/.test(text) ? `"${text.replace(/"/g, "\"\"")}"` : text;
  };
  return `﻿${[header, ...rows].map((row) => row.map(cell).join(",")).join("\r\n")}\r\n`;
}

export function downloadText(filename: string, text: string, type = "text/csv;charset=utf-8"): void {
  downloadBlob(filename, new Blob([text], { type }));
}

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
